export const BASIC = "BASIC";
export const COMPANY_ADMIN = "COMPANY_ADMIN";
export const GHOST = "GHOST";
export const ADMIN = "ADMIN";

export function isBasic(id) {
  return BASIC === id;
}

export function isAdmin(id) {
  return ADMIN === id;
}

export function isCompanyAdmin(id) {
  return COMPANY_ADMIN === id;
}

export function isGhost(id) {
  return GHOST === id;
}

export function canSeeReports(user) {
  return (
    user.canSeeAllReports ||
    user.canEditAcquisitionsReports ||
    user.canEditAccountingReports ||
    user.canEditReceptionReports
  );
}

export function canSeeContracts(user) {
  return user.canSeeContracts;
}

export function canSeeApprovedPapers(user) {
  return user.canSeeApprovedPapers;
}
export function canSeeAllPapers(user) {
  return user.canSeeAllPapers;
}
export function canSetPaperAsPrinted(user) {
  return user.canSetPaperAsPrinted;
}
